import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useReservationStore } from "@cinch-labs/data-reservations";
import { sendCheckoutError } from "./helpers/send-checkout-error";
import { ReservationsDecouplingPhase } from "./types";
export var addReservationToOrder = function() {
    var _ref = _async_to_generator(function(param) {
        var order, token, reservationServiceUrl, reservationsDecouplingPhase, getReservation, updatedExpiresAt;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    order = param.order, token = param.token, reservationServiceUrl = param.reservationServiceUrl, reservationsDecouplingPhase = param.reservationsDecouplingPhase;
                    getReservation = useReservationStore.getState().getReservation;
                    if (!(order === null || order === void 0 ? void 0 : order.id)) {
                        return [
                            2,
                            order
                        ];
                    }
                    if (!(reservationsDecouplingPhase === ReservationsDecouplingPhase.PHASE_ONE)) return [
                        3,
                        2
                    ];
                    // Emulate getting the reservation from the reservation service...
                    return [
                        4,
                        getReservation(order.id, reservationServiceUrl, token).catch(function(error) {
                            return sendCheckoutError("Error getting reservation (getReservation)", error, order.id);
                        })
                    ];
                case 1:
                    _state.sent();
                    // ...but just return the original order
                    return [
                        2,
                        order
                    ];
                case 2:
                    return [
                        4,
                        getReservation(order.id, reservationServiceUrl, token).catch(function(error) {
                            sendCheckoutError("Error getting reservation (getReservation)", error, order.id);
                            return null;
                        })
                    ];
                case 3:
                    updatedExpiresAt = _state.sent();
                    // ...then return the order with the updated expiresAt value (if it exists, otherwise return the original order)
                    return [
                        2,
                        _object_spread_props(_object_spread({}, order), {
                            expiresAt: updatedExpiresAt !== null && updatedExpiresAt !== void 0 ? updatedExpiresAt : order.expiresAt
                        })
                    ];
            }
        });
    });
    return function addReservationToOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
export var handleExtendReservation = function() {
    var _ref = _async_to_generator(function(param) {
        var orderId, token, orderServiceUrl, reservationServiceUrl, reservationsDecouplingPhase, ref, extendReservation, legacyExtendReservation, extendedOrder, extendedReservation;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    orderId = param.orderId, token = param.token, orderServiceUrl = param.orderServiceUrl, reservationServiceUrl = param.reservationServiceUrl, reservationsDecouplingPhase = param.reservationsDecouplingPhase;
                    ref = useReservationStore.getState(), extendReservation = ref.extendReservation, legacyExtendReservation = ref.legacyExtendReservation;
                    if (!(reservationsDecouplingPhase === ReservationsDecouplingPhase.PHASE_ONE)) return [
                        3,
                        2
                    ];
                    //! In phase one, we post to the reservations endpoint, but use the order service to extend the expiriesAt
                    extendReservation(orderId, reservationServiceUrl, token).catch(function(error) {
                        return sendCheckoutError("Error extending reservation (extendReservation)", error, orderId);
                    });
                    return [
                        4,
                        legacyExtendReservation(orderId, orderServiceUrl, token).catch(function(error) {
                            sendCheckoutError("Error extending reservation (extendOrderExpiryDate)", error, orderId);
                            return null;
                        })
                    ];
                case 1:
                    extendedOrder = _state.sent();
                    return [
                        2,
                        extendedOrder !== null && extendedOrder !== void 0 ? extendedOrder : undefined
                    ];
                case 2:
                    return [
                        4,
                        extendReservation(orderId, reservationServiceUrl, token).catch(function(error) {
                            sendCheckoutError("Error extending reservation (extendReservation)", error, orderId);
                            return null;
                        }).finally(function() {
                            // TODO: Remove this finally block once phase two is complete
                            if (reservationsDecouplingPhase === ReservationsDecouplingPhase.PHASE_TWO) {
                                // Finally, ping the legacy order service to keep them in sync
                                legacyExtendReservation(orderId, orderServiceUrl, token).catch(function(error) {
                                    return sendCheckoutError("Error extending reservation (extendOrderExpiryDate)", error, orderId);
                                });
                            }
                        })
                    ];
                case 3:
                    extendedReservation = _state.sent();
                    return [
                        2,
                        extendedReservation !== null && extendedReservation !== void 0 ? extendedReservation : undefined
                    ];
            }
        });
    });
    return function handleExtendReservation(_) {
        return _ref.apply(this, arguments);
    };
}();
